module.exports = __webpack_public_path__ + "manageStatic/img/zongdai.25438d40.png";